<div class="form-container" [formGroup]="submitForm">
  <lib-row-with-two-columns
    [breakpoint]="breakpointService.isPhoneViewObservable"
    [revertOrderOnBreakpoint]="true"
    [column1FxFlex]="simplifiedFormForGuestRegistration ? '0%' : '50%'"
    [column2FxFlex]="simplifiedFormForGuestRegistration ? '100%' : '50%'"
    [fxLayoutGap]="simplifiedFormForGuestRegistration ? '0' : '10px'"
  >
    @if (!simplifiedFormForGuestRegistration) {
    <!-- input surname -->
    <mat-form-field col-1>
      <mat-label>{{ 'customer-form.field.surname' | translate }}</mat-label>
      <input
        #surname
        [formControlName]="FORM_NAME.SURNAME"
        matInput
        autocapitalize="words"
      />
      <mat-hint align="end">
        {{ surname.value.length }} / {{ configValue.surname.maxLength }}
      </mat-hint>
      <mat-error>
        <lib-error-message-wrapper
          [maxLength]="configValue.surname.maxLength"
          [control]="controlSurname"
        ></lib-error-message-wrapper>
      </mat-error>
    </mat-form-field>
    }

    <!-- input name -->
    <mat-form-field col-2>
      <mat-label>{{ 'customer-form.field.name' | translate }}</mat-label>
      <input
        #name
        [formControlName]="FORM_NAME.NAME"
        matInput
        autocapitalize="words"
      />
      <mat-hint align="end">
        {{ name.value.length }} / {{ configValue.name.maxLength }}
      </mat-hint>
      <mat-error>
        <lib-error-message-wrapper
          [maxLength]="configValue.name.maxLength"
          [control]="controlName"
        ></lib-error-message-wrapper>
      </mat-error>
    </mat-form-field>
  </lib-row-with-two-columns>

  <lib-spacer [height]="5"></lib-spacer>

  <!-- phone number -->
  @if (!originalCustomer?.id || displayFullContactData) {
  <lib-phone-number-input
    [businessObject]="businessObject"
    [formControlName]="FORM_NAME.PHONE_NR"
  ></lib-phone-number-input>
  } @else {
  <mat-form-field>
    <mat-label>{{ 'customer-form.field.phone_nr' | translate }}</mat-label>
    <input
      [value]="originalCustomer?.phoneNr | phoneFormatter : true"
      [disabled]="true"
      matInput
      style="color: black"
    />
  </mat-form-field>
  }

  <lib-spacer [height]="5"></lib-spacer>

  <!-- input email -->
  @if(!simplifiedFormForGuestRegistration || controlCommunicationWay.value ===
  COMMUNICATION_WAY.EMAIL) { @if (!originalCustomer?.id ||
  displayFullContactData) {
  <mat-form-field>
    <mat-label>{{ 'customer-form.field.email' | translate }}</mat-label>
    <input #email [formControlName]="FORM_NAME.EMAIL" matInput />
    <mat-hint align="end">
      {{ email.value.length }} / {{ configValue.email.maxLength }}
    </mat-hint>
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlEmail"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>
  } @else {
  <mat-form-field>
    <mat-label>{{ 'customer-form.field.email' | translate }}</mat-label>
    <input
      [value]="originalCustomer?.email | emailFormatter : true"
      [disabled]="true"
      matInput
      style="color: black"
    />
  </mat-form-field>
  }

  <lib-spacer [height]="5"></lib-spacer>
  } @if(!simplifiedFormForGuestRegistration) {
  <lib-row-with-two-columns
    [breakpoint]="breakpointService.isTabletViewObservable"
    [revertOrderOnBreakpoint]="true"
    [column1FxFlex]="'50%'"
    [column2FxFlex]="'50%'"
    [fxLayoutGap]="'10px'"
  >
    <!-- input birthday -->
    <mat-form-field col-1>
      <mat-label>{{ 'customer-form.field.birthday' | translate }}</mat-label>
      <input
        (click)="dp3.open()"
        [formControlName]="FORM_NAME.BIRTHDAY"
        [matDatepicker]="dp3"
        readonly
        matInput
      />
      <mat-datepicker-toggle [for]="dp3" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #dp3 [touchUi]="true"></mat-datepicker>
    </mat-form-field>

    <!-- input note -->
    <mat-form-field col-2>
      <mat-label>{{ 'customer-form.field.note' | translate }}</mat-label>
      <textarea
        #note
        [formControlName]="FORM_NAME.NOTE"
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
      ></textarea>
      <mat-hint align="end">
        {{ note.value.length }} / {{ configValue.note.maxLength }}
      </mat-hint>
      <mat-error>
        <lib-error-message-wrapper
          [maxLength]="configValue.note.maxLength"
          [control]="controlNote"
        ></lib-error-message-wrapper>
      </mat-error>
    </mat-form-field>
  </lib-row-with-two-columns>
  } @if(originalCustomer?.id && isAbleToEditLoyalPoint) {
  <div fxLayout="row" fxLayoutGap="10px" style="width: calc(100% - 20px)">
    <!--current value-->
    <div fxFlex="33.33%" fxLayout="column" fxFlexFill>
      <mat-form-field>
        <mat-label>{{
          'customer-form.field.available_points' | translate
        }}</mat-label>
        <input
          [value]="originalCustomer.availableBonusPoints"
          disabled
          matInput
          style="color: black"
          type="number"
        />
      </mat-form-field>
    </div>

    <!--Update value-->
    <div fxFlex="33.33%" fxLayout="column" fxFlexFill>
      <mat-form-field>
        <mat-label>{{
          'customer-form.field.update_point_balance' | translate
        }}</mat-label>
        <input
          [formControlName]="FORM_NAME.POINT_UPDATE"
          matInput
          type="number"
        />
      </mat-form-field>
    </div>

    <!--new value (display if update value != 0)-->
    <div fxFlex="33.33%" fxLayout="column" fxFlexFill>
      @if(controlPointUpdate?.value) {
      <mat-form-field>
        <mat-label>{{
          'customer-form.field.new_point_balance' | translate
        }}</mat-label>
        <input
          [value]="
            originalCustomer.availableBonusPoints + controlPointUpdate.value
          "
          disabled
          matInput
          style="color: black"
          type="number"
        />
      </mat-form-field>
      }
    </div>
  </div>
  } @if(!simplifiedFormForGuestRegistration) {
  <lib-row-with-two-columns
    [breakpoint]="breakpointService.isPhoneViewObservable"
    [column1FxFlex]="'50%'"
    [column2FxFlex]="'50%'"
    [column1FxLayoutAlign]="'center start'"
    [column2FxLayoutAlign]="'center start'"
    [fxLayoutGap]="'10px'"
  >
    @if(isAbleToEditCommunicationWay) {
    <div
      col-1
      fxLayout="row"
      fxFlexFill
      [fxLayoutAlign]="
        (breakpointService.isPhoneViewObservable | async)
          ? 'space-between'
          : 'start center'
      "
    >
      <span>{{ 'customer-form.field.communication_way' | translate }}</span>
      <mat-radio-group [formControlName]="FORM_NAME.COMMUNICATION_WAY">
        <mat-radio-button color="primary" [value]="COMMUNICATION_WAY.SMS">
          {{ COMMUNICATION_WAY.SMS | communicationWayFormatter }}
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="COMMUNICATION_WAY.EMAIL">
          {{ COMMUNICATION_WAY.EMAIL | communicationWayFormatter }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    }@else {
    <mat-form-field col-1>
      <mat-label>{{
        'customer-form.field.communication_way' | translate
      }}</mat-label>
      <input
        [value]="controlCommunicationWay.value | communicationWayFormatter"
        disabled
        matInput
        style="color: black"
      />
    </mat-form-field>
    }

    <lib-slide-toggle-container
      col-2
      [isOn]="controlNotificationSubscribed.value"
      [flexLeft]="'70%'"
      [flexRight]="'30%'"
      [title]="'customer-form.field.notification_subscribed'"
      [textOn]="'customer-form.text.on'"
      [textOff]="'customer-form.text.off'"
    >
      <mat-slide-toggle
        [checked]="controlNotificationSubscribed.value"
        [formControlName]="FORM_NAME.NOTIFICATION_SUBSCRIBED"
        color="primary"
      ></mat-slide-toggle>
    </lib-slide-toggle-container>
  </lib-row-with-two-columns>
  } @if (originalCustomer?.id) {
  <lib-slide-toggle-container
    [isOn]="controlBlackListed.value"
    [flexLeft]="'50%'"
    [flexRight]="'50%'"
    [title]="'customer-form.field.black_listed'"
    [description]="'customer-form.field.black_listed_hint'"
    [textOn]="'customer-form.text.on'"
    [textOff]="'customer-form.text.off'"
  >
    <mat-slide-toggle
      [checked]="controlBlackListed.value"
      [formControlName]="FORM_NAME.BLACK_LISTED"
      color="primary"
    ></mat-slide-toggle>
  </lib-slide-toggle-container>
  }
</div>
